import { render } from "./AxesViewer.vue?vue&type=template&id=68a66dd8"
import script from "./AxesViewer.vue?vue&type=script&lang=js"
export * from "./AxesViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__